import { OnInit, EventEmitter, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
/**
 * Create a valididation function:
 *
 * should return an object if validation fails.
 * {
 *    exampleError: {
 *      given: a,
 *      expected: b
 *    }
 *  }
*/
// export function createValidatorFunction(input: InputComponent) {
//   // we can customize the validation function for extra needs
//   return function validate(c: FormControl) {
//     return !!input.externalValidation ? input.externalValidation(c) : null;
//   }
// }
var InputComponent = /** @class */ (function () {
    function InputComponent(domManipulationService) {
        this.domManipulationService = domManipulationService;
        this._model = '';
        // TOOD: look into setDisabledState
        // @Input() isDisabled: boolean = false;
        this.isFullWidth = false;
        this.inputType = 'text'; // password, number, etc
        this.placeholder = '';
        this.label = '';
        // pattern for invalid state checking ex: [a-Z]*
        this.pattern = '';
        // Extra check for errors apart from the normal state checking provided by the form
        this.hasErrors = false; // TODO: Is this obsolete?
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.modelChange = new EventEmitter();
        this.focus = false;
        this.isRequired = false;
        this.propagateChange = function () { };
        // validateFn: Function;
        // Function to call when the input is touched (when a star is clicked).
        this.onTouched = function () { };
        this.inputId = this.inputId ? this.inputId : 'element-id-' + Math.random();
    }
    InputComponent.prototype.ngOnInit = function () { };
    InputComponent.prototype.ngOnChanges = function (changes) {
        if (changes.model)
            this.propagateChange(this._model);
        if (this.focus) {
            this.domManipulationService.focus(this.inputRef);
        }
        else {
            this.domManipulationService.blur(this.inputRef);
        }
    };
    Object.defineProperty(InputComponent.prototype, "model", {
        get: function () { return this._model; },
        set: function (val) {
            this._model = val;
            this.propagateChange(this._model);
            this.modelChange.emit();
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "isInvalid", {
        get: function () {
            if (!this.formControl)
                return false;
            return (this.formControl.invalid && (this.formControl.dirty || this.formControl.touched));
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.onModelChange = function ($event) {
        this.modelChange.emit();
    };
    // Called when form is initialized, with form model's initial value
    InputComponent.prototype.writeValue = function (value) { if (value)
        this.model = value; };
    // Access to a function that informs the outside world about changes
    InputComponent.prototype.registerOnChange = function (fn) { this.propagateChange = fn; };
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    InputComponent.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    return InputComponent;
}());
export { InputComponent };
